import constants from "../../core/constants";
import moment from "moment";

class CorporateTransportationSubmissionPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (item) => {
      data.location = data.location || {};
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.updatedAt = moment(item.updatedAt).format(constants.dateTimeFormat);

      return item;
    };

    return format(data);
  }
}

export default CorporateTransportationSubmissionPageTransform;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmission/corporateTransportationSubmission.transforms.js